export default __webpack_public_path__ + "static/media/preloader.74bb1db9.gif";